export const CategoryArray = [
  'unique',
  'magnifique',
  'bonifique'
] as const;

export type Category = typeof CategoryArray[number];